<template>
  <game-javelin-component />
</template>

<script lang="ts">
import GameJavelinComponent from '@/components/GameJavelinComponent.vue'

import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    GameJavelinComponent
  },
})

</script>
